import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, Link, Icon, NakedButton, Image, Text } from '@qga/roo-ui/components';
import { ShareCtaStyling, ShareIcon, TooltipWrapper, CopyNotification } from './primitives';
import FadeInWrapper from 'components/FadeInWrapper';
import { useTooltip } from 'lib/hooks';
import facebookIcon from './facebook.svg';
import { useTimeoutFn } from 'react-use';

const POPPER_OPTIONS = {
  placement: 'bottom-end',
};

const TRANSITION_STYLE = {
  exiting: { opacity: 1 },
  entered: { opacity: 1 },
  exited: { opacity: 0 },
};

const SharePropertyTooltip = ({ propertyName, shareTypes }) => {
  const [isCopied, setIsCopied] = useState(false);
  const { triggerProps, tooltipProps, isOpen } = useTooltip('share-property-button', POPPER_OPTIONS);
  const { facebook, email, copyLink } = shareTypes;

  // eslint-disable-next-line no-unused-vars
  const [isReady, cancel, reset] = useTimeoutFn(() => setIsCopied(false), 1000);
  const handleCopyText = () => {
    setIsCopied(true);
    copyLink.callback();

    cancel();
    reset();
  };

  return (
    <Flex alignItems="center" justifyContent={['space-between', 'flex-end']} ml={4}>
      <NakedButton {...triggerProps} data-testid="share-tooltip-cta">
        <ShareCtaStyling>
          <ShareIcon name="share" size={[24, 32]} title="Share property" />
        </ShareCtaStyling>
      </NakedButton>
      {isOpen && (
        <Box {...tooltipProps} zIndex="loginToolTip" pt={4}>
          <TooltipWrapper>
            <Flex mb={2} data-testid="share-facebook">
              <Image src={facebookIcon} alt="facebook" mr={4} />
              <Link onClick={facebook.callback} href={`http://www.facebook.com/share.php?u=${facebook.url}`} color="greys.charcoal">
                Share via Facebook
              </Link>
            </Flex>
            <Box mb={2} data-testid="share-email">
              <Icon name="mailOutline" mr={4} />
              <Link
                onClick={email.callback}
                href={`mailto:?subject=Check out ${propertyName}&body=Check out this amazing hotel: ${email.url}`}
                color="greys.charcoal"
              >
                Share via Email
              </Link>
            </Box>
            <Box mb={2} data-testid="share-copy-link" position="relative">
              <Icon name="contentCopy" mr={4} />
              <NakedButton onClick={handleCopyText} color="greys.charcoal">
                Copy link
              </NakedButton>
              <FadeInWrapper isVisible={isCopied} transitionStyle={TRANSITION_STYLE}>
                <CopyNotification>
                  <Text color="white">Link Copied!</Text>
                </CopyNotification>
              </FadeInWrapper>
            </Box>
          </TooltipWrapper>
        </Box>
      )}
    </Flex>
  );
};

SharePropertyTooltip.propTypes = {
  propertyName: PropTypes.string.isRequired,
  shareTypes: PropTypes.shape({
    facebook: PropTypes.object,
    email: PropTypes.object,
    copyLink: PropTypes.object,
  }).isRequired,
};

export default SharePropertyTooltip;
